import styled from "styled-components"

export const StyledHeaderDiv = styled.div`
    width: 100%;
    text-align: center;
    padding: 10px 0 70px 0;
`
export const StyledHeaderEl = styled.p`
    font-family: Inter;
    font-weight: 700;
    font-size: 1.5rem;
    color: rgb(50, 63, 75);
`

export const StyledSpanEl = styled.span`
    color: rgb(249, 115, 22);
`